//授课计划
export const PLAN_LIST = 'plan_list'
export const PLAN_INFO = 'plan_info'
export const Talk_INFO = 'talk_info'
export const COURSE_LIST = 'course_info'
export const COURSE_DELETE = 'course_delete'
export const ADD_XZ_CLASS = 'add_xz_class'
export const VIEW_COURSE_TREE = 'view_course_tree'
